import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { UseGetStatement } from "../../../core/services/api/get-statement";
import StatementCardList from "./StatementCardList";
import SkeletonCard from "./StatementSkeleton";
import EmptyPage from "../../common/EmptyPage/EmptyPage";
import "./StatementList.scss";

const StatementList = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 12;

  const { data, isLoading, isError } = UseGetStatement({
    page: pageNumber,
    pageSize,
  });

  const statements = data?.data?.result?.statementList || [];
  const totalCount = data?.data?.result?.totalCount || 0;
  const pageCount = Math.ceil(totalCount / pageSize);

  const iconStyle = { color: "#0B1803", fontSize: "24px" };

  if (isLoading) {
    return (
      <div className="statement-list-container">
        <div className="statement-grid">
          {Array.from({ length: pageSize }).map((_, idx) => (
            <SkeletonCard key={idx} />
          ))}
        </div>
      </div>
    );
  }

  if (isError) {
    return <EmptyPage />;
  }

  return (
    <div className="statement-list-container">
      <h1 className="statement-list-title">بیاینه و اطلاعیه</h1>

      {statements.length === 0 ? (
        <p className="statement-list-empty">هیچ موردی یافت نشد</p>
      ) : (
        <>
          <div className="statement-grid">
            {statements.map((item) => (
              <StatementCardList
                key={item?.id}
                id={item?.id}
                title={item?.title}
                image={item?.imagePath}
                statementData={item}
              />
            ))}
          </div>

          {pageCount > 1 && (
            <div className="pagination-wrapper">
              <ReactPaginate
                previousLabel={
                  <span>
                    <IoIosArrowForward style={iconStyle} />
                  </span>
                }
                nextLabel={
                  <span>
                    <IoIosArrowBack style={iconStyle} />
                  </span>
                }
                breakLabel="..."
                pageCount={pageCount}
                containerClassName="pagination-holder"
                activeClassName="page-active"
                forcePage={pageNumber - 1}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                onPageChange={({ selected }) => setPageNumber(selected + 1)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export { StatementList };
